import { z } from "zod";
import {
  CATEGORY_NAME,
  DESCRIPTION,
  SUB_CATEGORY,
  SUB_CATEGORY_DESC,
  SUB_CATEGORY_NAME,
} from "./consts";

export const addSchema = z.object({
  [CATEGORY_NAME]: z.string().min(1, "This field is required"),
  [DESCRIPTION]: z.string().optional(),
  [SUB_CATEGORY]: z
    .object({
      [SUB_CATEGORY_NAME]: z.string().min(1, "This field is required"),
      [SUB_CATEGORY_DESC]: z.string().optional(),
    })
    .array().min(1, "At least one Sub Category is required"),
});

export type AddCategoryFormValues = z.infer<typeof addSchema>;
